import { v4 } from 'uuid';

const generateCustomId = () => v4();
const generateDisplayId = () => generateCustomId().slice(-6).toUpperCase();

export { generateCustomId, generateDisplayId };
